import React, { useState, useEffect, useContext, useRef } from "react"
import { Button, message, Dropdown, Flex, Input } from "antd"
import { UserContext, useUser } from "../../contexts/UserContext"
import { useTranslation } from "react-i18next"
import { getOrganizations, getResellers, createNewAccount } from "../../api/Cards/users"

const AdminFields = ({ messageApi }) => {
    const { t } = useTranslation()
    const { user } = useContext(UserContext)
    const [organizations, setOrganizations] = useState([])
    const [selectedOrganization, setSelectedOrganization] = useState(null)
    const [invalidFields, setInvalidFields] = useState(false)
    const userData = useRef({})

    useEffect(() => {

        async function getOrgs() {
            const data = await getOrganizations(user.token)

            if (typeof data === "number") {
                return
            }

            setOrganizations(data)
        }
        getOrgs();

    }, [])



    function getOrganizationItems() {

        var items = []
        for (var i = 0; i < Object.keys(organizations).length; ++i) {
            items.push(
                { key: i + 1, label: organizations[i + 1].OrganizationName }
            )
        }

        return items
    }

    function getSelectedOrganization() {
        if (selectedOrganization === null)
            return t('page.newaccount.ufield.chooseorg')

        return selectedOrganization.OrganizationName
    }

    function getStatus(parameter) {
        if (invalidFields && !parameter)
            return "error";

        return ""
    }

    function submitNewAccount() {

        if (
            !userData.current.FirstName ||
            !userData.current.LastName ||
            !userData.current.EMail ||
            !userData.current.Address ||
            !userData.current.Phone ||
            !selectedOrganization
        ) {
            setInvalidFields(true);
            return;
        }

        async function createUser() {
            var newUser = {
                Token: user.token,
                NewUserRequest: {
                    ...userData.current,
                    Role: 2,    //User
                    SellerID: 0,
                    OrgID: selectedOrganization.OrganizationId,
                    OrgName: ""
                }
            }

            var res = await createNewAccount(newUser)
            if (typeof res === "number") {
                console.log("FAILED TO CREATE ADMIN")

                if (res == 409)
                    messageApi.error(t('page.newaccount.ufield.alreadyexists'))

                else
                    messageApi.error(t('page.newaccount.ufield.unknownerror'))

                return;
            }

            messageApi.success(t('page.newaccount.ufield.newacc'))
        }
        createUser();
    }

    return (
        <>
            <div style={{ width: "300px" }} >
                <Input style={{ marginTop: "10px" }} status={getStatus(userData.current.FirstName)} size="large" onChange={(e) => { userData.current.FirstName = e.target.value }} placeholder={t('page.editaccount.fname')} ></Input>
                <Input style={{ marginTop: "10px" }} status={getStatus(userData.current.LastName)} size="large" onChange={(e) => { userData.current.LastName = e.target.value }} placeholder={t('page.editaccount.lname')} ></Input>
                <Input style={{ marginTop: "10px" }} status={getStatus(userData.current.EMail)} size="large" onChange={(e) => { userData.current.EMail = e.target.value }} placeholder={t('page.editaccount.email')} ></Input>
                <Input style={{ marginTop: "10px" }} status={getStatus(userData.current.Address)} size="large" onChange={(e) => { userData.current.Address = e.target.value }} placeholder={t('page.editaccount.adress')} ></Input>
                <Input style={{ marginTop: "10px" }} status={getStatus(userData.current.Phone)} size="large" onChange={(e) => { userData.current.Phone = e.target.value }} placeholder={t('page.editaccount.phone')} ></Input>
                <Dropdown menu={{ items: getOrganizationItems(), onClick: (e) => { setSelectedOrganization(organizations[e.key]) } }}><Button style={getStatus(selectedOrganization) == "error" ? { borderColor: "red", marginTop: "10px", width: "100%" } : { marginTop: "10px", width: "100%" }}>{getSelectedOrganization()}</Button></Dropdown>
                <Button style={{ marginTop: "50px", width: "100%" }} type="primary" onClick={submitNewAccount}>{t('page.newaccount.afield.create')}</Button>

            </div>
        </>
    )
}

export default AdminFields